export default class EnhanceExposedFilters {
  constructor(element) {
    // Modify the apply/submit button
    const submit = element.querySelector('.form-submit');
    if (!submit) return;
    submit.value = 'Submit';

    // Create a reset button
    const reset = document.createElement('input');
    reset.type = 'reset';
    reset.id = 'edit-reset-document-library';
    reset.className = 'form-submit form-reset';
    reset.value = 'Reset';

    // Create a reset button wrapper
    const widget = document.createElement('div');
    widget.className = 'views-exposed-widget views-reset-button';
    submit.parentNode.parentNode.append(widget);
    widget.append(reset);

    // Reset page to it's default state when reset is clicked.
    reset.addEventListener('click', () => {
      window.location.reload();
    });
  }
}
